/**
 * Скрытая страница админки: вход или панель.
 */

import { useCallback, useState } from "react";
import DevLogin from "../components/DevAdmin/DevLogin";
import DevPanel from "../components/DevAdmin/DevPanel";
import "../components/DevAdmin/DevAdmin.css";
import { clearDevToken, getDevToken } from "../utils/devAuth";

function DevPage() {
    const [token, setToken] = useState(() => getDevToken());

    const handleLogout = useCallback(() => {
        clearDevToken();
        setToken("");
    }, []);

    if (!token) {
        return <DevLogin onSuccess={setToken} />;
    }

    return <DevPanel token={token} onLogout={handleLogout} />;
}

export default DevPage;
// pages/DevPage.js
